import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import IPBoardPlacement from '../../../../model/product/ip-board/ip-board-placement';
import IPBoard from '../../../../model/product/ip-board/ip-board';
import IPBoardPlacementType, {
  IPBoardPlacementTypeChoices,
} from 'src/app/model/product/ip-board/ip-board-placement-type';

@Component({
  selector: 'ip-board-height',
  templateUrl: './ip-board-height.component.html',
  styleUrls: ['./ip-board-height.component.scss'],
})
export class IpBoardHeightComponent implements OnInit {
  @Input()
  ipBoard: IPBoard;
  @Input()
  multiple: boolean;
  @Input()
  index: number;
  @Output()
  update = new EventEmitter<any>();

  ipBoardPlacement: IPBoardPlacement;
  ON_POSTS: IPBoardPlacementType = IPBoardPlacementTypeChoices.ON_POSTS;
  ON_STONES: IPBoardPlacementType = IPBoardPlacementTypeChoices.ON_STONES;

  ngOnInit(): void {
    this.ipBoardPlacement = <IPBoardPlacement>this.ipBoard.productPlacement;
  }

  extraHeightChanged(): void {
    this.update.emit();
  }
}
